// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
*, *::before, *::after {
    box-sizing: border-box;
}

* {
    margin: 0;
}

html, body {
    height: 100%;

}

#root {
    height: 100%;
}

.w100 {
    width: 100%;
}

.disabledPointerEvents {
    pointer-events: none;
}

body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    scroll-behavior: smooth;
    position: relative;
    background-color: rgba(230, 230, 230, 1);

}

.zIndex555{
    z-index: 555!important;
}
#popup-cluster-point-content {
    width: 300px;
}

.darkTheme {
    & .darkThemeWhiteFill {
        fill: #ffffff;
    }

    & .darkThemeBgGray {
        background-color: #757575 !important;
    }

    & .recharts-default-tooltip {
        background-color: #757575 !important;
    }

}

.sr-only {
    display: none;
}

.activePolygon {
    z-index: 66666666666666666666666666666;
}

img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
}

input, button, textarea, select {
    font: inherit;
}

p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
}

a {
    text-decoration: none;
    color: inherit;
}

#root, #__next {
    isolation: isolate;
}

.isLoading {
    opacity: .5;
    pointer-events: none;
}

.deviceIconCustomWrapper:after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% + 10px);
    border-radius: 50%;
    z-index: -1;
    height: calc(100% + 10px);

}

.disablePointerEvens {
    pointer-events: none !important;
    cursor: default;
}

.deviceIconCustom {
    z-index: 6666666666 !important;
}

.mapActiveZIndex {
    z-index: 5666666666 !important;
}


.bodyLoading {
    position: relative;
    opacity: .9;
    pointer-events: none;
    z-index: 55;
    overflow: hidden;

    &:after {
        content: attr(data-loading);
        box-sizing: border-box;
        position: fixed;
        top: 50%;
        left: 50%;
        color: white;
        transform: translate(-50%, -50%);
        z-index: 99999999999;
    }

    &:before {
        position: fixed;
        content: '';
        z-index: 99999999;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.8);
        width: 100vw;
        height: calc(100dvh);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

}

.spinnerLoading {
    position: relative;
    opacity: .9;
    pointer-events: none;
    z-index: 55;
    overflow: hidden;

    &:after {
        content: '';
        box-sizing: border-box;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 70px;
        height: 70px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border: 2px solid transparent;
        border-top-color: #07d;
        border-bottom-color: #07d;
        animation: spinner .8s ease infinite;
        z-index: 99999999999;
    }

    &:before {
        position: fixed;
        content: '';
        z-index: 99999999;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.8);
        width: 100vw;
        height: calc(100dvh - 2px);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }
}


.MuiCheckbox-root {
    min-width: 30px;
}

.MuiPickersLayout-root {
    height: 390px;
}


@media (min-width: 1200px) {
    body {
        overflow: hidden;
    }

    *::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 12px;

        background-color: rgba(255, 255, 255, .5);
        height: 12px;
    }

    .blue-scrollbar::-webkit-scrollbar-thumb {
        background-color: #c0ebfe;
        border-radius: 4px;
        width: 8px;
        height: 77px;
        padding-right: 5px;
    }


    *::-webkit-scrollbar-thumb {
        background-color: rgba(77, 77, 77, 255);
    }

    *::-webkit-scrollbar-corner {
        background-color: rgba(255, 255, 255, .5);
    }

    .darkTheme *::-webkit-scrollbar {
        background-color: rgba(77, 77, 77, 255);
    }

    .darkTheme *::-webkit-scrollbar-thumb {
        background-color: rgba(255, 255, 255, .5);
    }

    .darkTheme *::-webkit-scrollbar-corner {
        background-color: rgba(77, 77, 77, 255)
    }

    .spinnerLoading {
        &:after {
            transform: translate(-50%, -50%);
            width: 50px;
            height: 50px;
        }
    }
}


@media print {
    @page {
        size: A4;
        margin: 12mm;
    }

    html, body, #root {
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
        background-color: #ffffff !important;
    }

    body:has(.printSheet) *:not(:has(.printSheet)):not(.printSheet):not(.printSheet *) {
        display: none !important;
    }

    body:has(.MuiModal-root .printSheet) #root {
        display: none !important;
    }

    body *:has(.printSheet) {
        display: block !important;
        position: static !important;
        overflow: visible !important;
        width: auto !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        box-shadow: none !important;
        transform: none !important;
        background: none !important;
    }

    .printSheet {
        position: static !important;
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        background-color: #ffffff !important;
    }

    .printHidden {
        display: none !important;
    }

    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/appProvider/baseAppProvider/styles.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;;AAE5C;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,oCAAoC;IACxC;;AAEJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;;AAE7B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gBAAgB;;IAEhB;QACI,2BAA2B;QAC3B,sBAAsB;QACtB,eAAe;QACf,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,gCAAgC;QAChC,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,sBAAsB;QACtB,8BAA8B;QAC9B,YAAY;QACZ,oBAAoB;QACpB,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;IACb;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gBAAgB;;IAEhB;QACI,WAAW;QACX,sBAAsB;QACtB,eAAe;QACf,QAAQ;QACR,SAAS;QACT,gCAAgC;QAChC,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,6BAA6B;QAC7B,sBAAsB;QACtB,yBAAyB;QACzB,oCAAoC;QACpC,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,sBAAsB;QACtB,8BAA8B;QAC9B,YAAY;QACZ,0BAA0B;QAC1B,OAAO;QACP,QAAQ;QACR,MAAM;QACN,SAAS;IACb;AACJ;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QACxB,WAAW;;QAEX,yCAAyC;QACzC,YAAY;IAChB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,kBAAkB;IACtB;;;IAGA;QACI,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI;IACJ;;IAEA;QACI;YACI,gCAAgC;YAChC,WAAW;YACX,YAAY;QAChB;IACJ;AACJ;;;AAGA;IACI;QACI,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;QACxB,4BAA4B;QAC5B,oCAAoC;IACxC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;QAC5B,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,2BAA2B;QAC3B,oBAAoB;QACpB,qBAAqB;QACrB,oBAAoB;QACpB,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,2BAA2B;QAC3B,sBAAsB;QACtB,0BAA0B;QAC1B,oBAAoB;QACpB,qBAAqB;QACrB,oBAAoB;QACpB,2BAA2B;QAC3B,2BAA2B;QAC3B,oCAAoC;IACxC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,4CAA4C;QAC5C,oCAAoC;IACxC;AACJ","sourcesContent":["\n*, *::before, *::after {\n    box-sizing: border-box;\n}\n\n* {\n    margin: 0;\n}\n\nhtml, body {\n    height: 100%;\n\n}\n\n#root {\n    height: 100%;\n}\n\n.w100 {\n    width: 100%;\n}\n\n.disabledPointerEvents {\n    pointer-events: none;\n}\n\nbody {\n    line-height: 1.5;\n    -webkit-font-smoothing: antialiased;\n    scroll-behavior: smooth;\n    position: relative;\n    background-color: rgba(230, 230, 230, 1);\n\n}\n\n.zIndex555{\n    z-index: 555!important;\n}\n#popup-cluster-point-content {\n    width: 300px;\n}\n\n.darkTheme {\n    & .darkThemeWhiteFill {\n        fill: #ffffff;\n    }\n\n    & .darkThemeBgGray {\n        background-color: #757575 !important;\n    }\n\n    & .recharts-default-tooltip {\n        background-color: #757575 !important;\n    }\n\n}\n\n.sr-only {\n    display: none;\n}\n\n.activePolygon {\n    z-index: 66666666666666666666666666666;\n}\n\nimg, picture, video, canvas, svg {\n    display: block;\n    max-width: 100%;\n}\n\ninput, button, textarea, select {\n    font: inherit;\n}\n\np, h1, h2, h3, h4, h5, h6 {\n    overflow-wrap: break-word;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\n#root, #__next {\n    isolation: isolate;\n}\n\n.isLoading {\n    opacity: .5;\n    pointer-events: none;\n}\n\n.deviceIconCustomWrapper:after {\n    content: '';\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: calc(100% + 10px);\n    border-radius: 50%;\n    z-index: -1;\n    height: calc(100% + 10px);\n\n}\n\n.disablePointerEvens {\n    pointer-events: none !important;\n    cursor: default;\n}\n\n.deviceIconCustom {\n    z-index: 6666666666 !important;\n}\n\n.mapActiveZIndex {\n    z-index: 5666666666 !important;\n}\n\n\n.bodyLoading {\n    position: relative;\n    opacity: .9;\n    pointer-events: none;\n    z-index: 55;\n    overflow: hidden;\n\n    &:after {\n        content: attr(data-loading);\n        box-sizing: border-box;\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        color: white;\n        transform: translate(-50%, -50%);\n        z-index: 99999999999;\n    }\n\n    &:before {\n        position: fixed;\n        content: '';\n        z-index: 99999999;\n        box-sizing: border-box;\n        background: rgba(0, 0, 0, 0.8);\n        width: 100vw;\n        height: calc(100dvh);\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n    }\n\n}\n\n.spinnerLoading {\n    position: relative;\n    opacity: .9;\n    pointer-events: none;\n    z-index: 55;\n    overflow: hidden;\n\n    &:after {\n        content: '';\n        box-sizing: border-box;\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 70px;\n        height: 70px;\n        margin-top: -10px;\n        margin-left: -10px;\n        border-radius: 50%;\n        border: 2px solid transparent;\n        border-top-color: #07d;\n        border-bottom-color: #07d;\n        animation: spinner .8s ease infinite;\n        z-index: 99999999999;\n    }\n\n    &:before {\n        position: fixed;\n        content: '';\n        z-index: 99999999;\n        box-sizing: border-box;\n        background: rgba(0, 0, 0, 0.8);\n        width: 100vw;\n        height: calc(100dvh - 2px);\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n    }\n}\n\n\n.MuiCheckbox-root {\n    min-width: 30px;\n}\n\n.MuiPickersLayout-root {\n    height: 390px;\n}\n\n\n@media (min-width: 1200px) {\n    body {\n        overflow: hidden;\n    }\n\n    *::-webkit-scrollbar {\n        -webkit-appearance: none;\n        width: 12px;\n\n        background-color: rgba(255, 255, 255, .5);\n        height: 12px;\n    }\n\n    .blue-scrollbar::-webkit-scrollbar-thumb {\n        background-color: #c0ebfe;\n        border-radius: 4px;\n        width: 8px;\n        height: 77px;\n        padding-right: 5px;\n    }\n\n\n    *::-webkit-scrollbar-thumb {\n        background-color: rgba(77, 77, 77, 255);\n    }\n\n    *::-webkit-scrollbar-corner {\n        background-color: rgba(255, 255, 255, .5);\n    }\n\n    .darkTheme *::-webkit-scrollbar {\n        background-color: rgba(77, 77, 77, 255);\n    }\n\n    .darkTheme *::-webkit-scrollbar-thumb {\n        background-color: rgba(255, 255, 255, .5);\n    }\n\n    .darkTheme *::-webkit-scrollbar-corner {\n        background-color: rgba(77, 77, 77, 255)\n    }\n\n    .spinnerLoading {\n        &:after {\n            transform: translate(-50%, -50%);\n            width: 50px;\n            height: 50px;\n        }\n    }\n}\n\n\n@media print {\n    @page {\n        size: A4;\n        margin: 12mm;\n    }\n\n    html, body, #root {\n        height: auto !important;\n        min-height: 0 !important;\n        overflow: visible !important;\n        background-color: #ffffff !important;\n    }\n\n    body:has(.printSheet) *:not(:has(.printSheet)):not(.printSheet):not(.printSheet *) {\n        display: none !important;\n    }\n\n    body:has(.MuiModal-root .printSheet) #root {\n        display: none !important;\n    }\n\n    body *:has(.printSheet) {\n        display: block !important;\n        position: static !important;\n        overflow: visible !important;\n        width: auto !important;\n        height: auto !important;\n        min-height: 0 !important;\n        max-height: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        border: 0 !important;\n        box-shadow: none !important;\n        transform: none !important;\n        background: none !important;\n    }\n\n    .printSheet {\n        position: static !important;\n        width: 100% !important;\n        max-width: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n        border: 0 !important;\n        border-radius: 0 !important;\n        box-shadow: none !important;\n        background-color: #ffffff !important;\n    }\n\n    .printHidden {\n        display: none !important;\n    }\n\n    * {\n        -webkit-print-color-adjust: exact !important;\n        print-color-adjust: exact !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
